<template>
  <v-container>
    <div class="medical-information-list">
      <v-row class="my-2">
        <v-col>
          <h2 class="text-no-wrap">
            医療情報配信：配信履歴一覧
          </h2>
        </v-col>
        <v-col class="pl-0 d-flex justify-end align-center">
          <div class="picker-align-right">
            <month-picker
              v-model:selectedDate="selectedDate"
              @on-month-changed="saveSelectedDate"
            />
          </div>
        </v-col>
      </v-row>
      <template v-if="medicalInformations.length > 0">
        <medical-information-cards
          :medical-informations="medicalInformations"
        />
      </template>
      <template v-else>
        <div>
          指定月に配信された医療情報はまだありません。
        </div>
      </template>
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue"
import { useStore } from "../stores/index"
import monthPicker from "./shared/MonthPicker.vue"
import medicalInformationCards from "./shared/MedicalInformation.vue"
import { MedicalInformation } from "../stores/store_types"

export default defineComponent({
  name: "MedicalInformationListPage",
  components: {
    monthPicker,
    medicalInformationCards
  },
  setup() {
    const store = useStore()

    // data
    const medicalInformations = computed(() => store.getters.monthlyMedicalInformations as Array<MedicalInformation>)
    const selectedDate = computed(() => new Date(store.getters.selectedMedicalInformationDate))

    const saveSelectedDate = async (selectedValue: Date) => {
      await store.dispatch("commitSelectedMedicalInformationDate", selectedValue)
    }

    onMounted(() => {
      store.dispatch("commitSelectedMedicalInformationDate", selectedDate.value)
    })

    return {
      selectedDate,
      medicalInformations,
      saveSelectedDate
    }
  }
})
</script>
